export type Edge = 'top' | 'bottom' | 'left' | 'right'

/**
 * Get the closest edge of the element based on the mouse position
 * @param event - The mouse event
 * @param element - The element to get the edge of
 * @returns The edge of the mouse event
 */
export function getMouseEdge(event: MouseEvent, element: HTMLElement): Edge {
  const rect = element.getBoundingClientRect()
  const x = event.clientX - rect.left
  const y = event.clientY - rect.top

  // Calculate distance from each edge as a percentage of width/height
  const distanceTop = y
  const distanceBottom = rect.height - y
  const distanceLeft = x
  const distanceRight = rect.width - x

  // Find the minimum distance
  const minDistance = Math.min(
    distanceTop,
    distanceBottom,
    distanceLeft,
    distanceRight,
  )

  if (minDistance === distanceTop) return 'top'
  if (minDistance === distanceRight) return 'right'
  if (minDistance === distanceBottom) return 'bottom'
  return 'left'
}
